import { useCallback } from 'react';
import { CompanyProfileIndustry } from '~api';
import { useFormatMessage } from './use-format-message';

export const useFormatIndustry = () => {
  const formatMessage = useFormatMessage();

  return useCallback(
    (industry: CompanyProfileIndustry | null | undefined) => {
      if (!industry) {
        return '';
      }

      const mapIndustryToTranslation = {
        [CompanyProfileIndustry.AGRICULTURE_FORESTRY_AND_FISHING]: formatMessage({
          id: `comp.industry.agriculture_forestry_and_fishing`,
          defaultMessage: 'Agriculture, Forestry and Fishing',
        }),
        [CompanyProfileIndustry.ARTS_MEDIA_AND_ENTERTAINMENT]: formatMessage({
          id: `comp.industry.arts_media_and_entertainment`,
          defaultMessage: 'Arts, Media and Entertainment',
        }),
        [CompanyProfileIndustry.AUTOMOTIVE]: formatMessage({
          id: `comp.industry.automotive`,
          defaultMessage: 'Automotive',
        }),
        [CompanyProfileIndustry.CARE]: formatMessage({
          id: `comp.industry.care`,
          defaultMessage: 'Care',
        }),
        [CompanyProfileIndustry.CONSTRUCTION]: formatMessage({
          id: `comp.industry.construction`,
          defaultMessage: 'Construction',
        }),
        [CompanyProfileIndustry.EDUCATION]: formatMessage({
          id: `comp.industry.education`,
          defaultMessage: 'Education',
        }),
        [CompanyProfileIndustry.ENERGY_MINING_AND_UTILITIES]: formatMessage({
          id: `comp.industry.energy_mining_and_utilities`,
          defaultMessage: 'Energy, Mining, and Utilities',
        }),
        [CompanyProfileIndustry.ENVIRONMENTAL_PROTECTION]: formatMessage({
          id: `comp.industry.environmental_protection`,
          defaultMessage: 'Environmental Protection',
        }),
        [CompanyProfileIndustry.FINANCIAL_SERVICES]: formatMessage({
          id: `comp.industry.financial_services`,
          defaultMessage: 'Financial Services',
        }),
        [CompanyProfileIndustry.GOVERNMENT_AND_PUBLIC_ADMINISTRATION]: formatMessage({
          id: `comp.industry.government_and_public_administration`,
          defaultMessage: 'Government & Public Administration',
        }),
        [CompanyProfileIndustry.HEALTH_AND_BEAUTY]: formatMessage({
          id: `comp.industry.health_and_beauty`,
          defaultMessage: 'Health and beauty',
        }),
        [CompanyProfileIndustry.HEALTHCARE]: formatMessage({
          id: `comp.industry.healthcare`,
          defaultMessage: 'Healthcare',
        }),
        [CompanyProfileIndustry.HUMANRESOURCES_AND_RECRUITMENT]: formatMessage({
          id: `comp.industry.humanresources_and_recruitment`,
          defaultMessage: 'Human Resources & Recruitment',
        }),
        [CompanyProfileIndustry.INFORMATION_TECHNOLOGY]: formatMessage({
          id: `comp.industry.information_technology`,
          defaultMessage: 'Information Technology',
        }),
        [CompanyProfileIndustry.INSURANCE]: formatMessage({
          id: `comp.industry.insurance`,
          defaultMessage: 'Insurance',
        }),
        [CompanyProfileIndustry.LEGAL_SERVICES]: formatMessage({
          id: `comp.industry.legal_services`,
          defaultMessage: 'Legal Services',
        }),
        [CompanyProfileIndustry.MAINTENANCE_SERVICES]: formatMessage({
          id: `comp.industry.maintenance_services`,
          defaultMessage: 'Maintenance Services',
        }),
        [CompanyProfileIndustry.MANAGEMENT_AND_CONSULTING]: formatMessage({
          id: `comp.industry.management_and_consulting`,
          defaultMessage: 'Management & Consulting',
        }),
        [CompanyProfileIndustry.MANUFACTURING]: formatMessage({
          id: `comp.industry.manufacturing`,
          defaultMessage: 'Manufacturing',
        }),
        [CompanyProfileIndustry.MARKETING]: formatMessage({
          id: `comp.industry.marketing`,
          defaultMessage: 'Marketing',
        }),
        [CompanyProfileIndustry.NONPROFIT_AND_NGOS]: formatMessage({
          id: `comp.industry.nonprofit_and_ngos`,
          defaultMessage: 'Nonprofit & NGOs',
        }),
        [CompanyProfileIndustry.PHARMACEUTICAL_AND_BIOTECHNOLOGY]: formatMessage({
          id: `comp.industry.pharmaceutical_and_biotechnology`,
          defaultMessage: 'Pharmaceutical & Biotechnology',
        }),
        [CompanyProfileIndustry.REAL_ESTATE]: formatMessage({
          id: `comp.industry.real_estate`,
          defaultMessage: 'Real Estate',
        }),
        [CompanyProfileIndustry.RESTAURANTS_AND_FOOD_SERVICE]: formatMessage({
          id: `comp.industry.restaurants_and_food_service`,
          defaultMessage: 'Restaurants & Food Service',
        }),
        [CompanyProfileIndustry.RETAIL_AND_WHOLESALE]: formatMessage({
          id: `comp.industry.retail_and_wholesale`,
          defaultMessage: 'Retail & Wholesale',
        }),
        [CompanyProfileIndustry.SECURITY]: formatMessage({
          id: `comp.industry.security`,
          defaultMessage: 'Security',
        }),
        [CompanyProfileIndustry.TELECOMMUNICATIONS]: formatMessage({
          id: `comp.industry.telecommunications`,
          defaultMessage: 'Telecommunications',
        }),
        [CompanyProfileIndustry.TOURISM]: formatMessage({
          id: `comp.industry.tourism`,
          defaultMessage: 'Tourism',
        }),
        [CompanyProfileIndustry.TRANSPORTATION_AND_LOGISTICS]: formatMessage({
          id: `comp.industry.transportation_and_logistics`,
          defaultMessage: 'Transportation & Logistics',
        }),
      };

      return mapIndustryToTranslation[industry];
    },
    [formatMessage],
  );
};
